import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveOffcanvas, NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-offcanvas-tasks',
  template: `
    <div class="offcanvas-header">
      <h4 class="offcanvas-title">Filtro</h4>      
			<button
				type="button"
				class="btn-close"
				aria-label="Close"
				(click)="dismiss()"
			></button>
    </div>
    <div class="offcanvas-body">
    <form [formGroup]="filterForm">
      <div class="form-group">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
          <label class="form-check-label" for="defaultCheck1">Condominios</label>
        </div>
      </div>
    </form>
  `,
  styles: ``
})
export class OffcanvasTasksComponent {
  @Input() profile: any;
  @Input() toDate: NgbDate | null;
  @Input() fromDate: NgbDate | null;
  @Input() payload: any;

  @Output() dateRange = new EventEmitter<any>();
  @Output() billsSettlement = new EventEmitter<any>();
  @Output() billsBuilding = new EventEmitter<any>();
  @Output() billsFloor = new EventEmitter<any>();
  @Output() billsUnit = new EventEmitter<any>();
  @Output() billsSort = new EventEmitter<any>();
  @Output() billsOrder = new EventEmitter<any>();
  @Output() billsPerPage = new EventEmitter<any>();
  @Output() clear = new EventEmitter<any>();

  settlements: any = [];
  buildings: any = [];
  floors: any = [];
  units: any = [];

  searchActive: boolean = false;

  filterForm: FormGroup = new FormGroup({});

  constructor(
    private store: SettlementsService,
    private router: Router,
    private route: ActivatedRoute,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter,
    public icons: IconsService,
    private fb: FormBuilder,
    public activeOffcanvas: NgbActiveOffcanvas,
  ) { 
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  ngOnInit(): void {
    this.initForm();
    this.loadSettlements();

    console.log("CANVAS PAYLOAD ====> ", this.payload);
    console.log('CANVAS PROFILE ====> ', this.profile);
  }

  initForm() {
    this.filterForm = this.fb.group({
      settlement_id: [''],
      building_id: [''],
      floor_id: [''],
      unit_id: [''],
      sort: [''],
      order: [''],
      per_page: ['']
    });

    this.filterForm.patchValue(this.payload);
  }

  dismiss() {
    this.activeOffcanvas.dismiss('Cross click');
  }

  close() {
    let payload: any = {};
    const ff = this.filterForm.value;
    if (ff.settlement_id) {
      payload.settlement_id = ff.settlement_id;
    }
    if (ff.building_id) {
      payload.building_id = ff.building_id;
    }
    if (ff.floor_id) {
      payload.floor_id = ff.floor_id;
    }
    if (ff.unit_id) {
      payload.unit_id = ff.unit_id;
    }
    if (ff.sort) {
      payload.sort = ff.sort;
    }
    if (ff.per_page) {
      payload.per_page = ff.per_page;
    }
    this.activeOffcanvas.close(payload);
  }

  loadSettlements(id: any = null) {
    let settlementPayload: any = {
      page: 1,
      per_page: 300,
      utility_id: this.profile.utility_id
    };
    this.store.getSettlements(settlementPayload).subscribe((data: any) => {
      this.settlements = data.data;
      
      console.log("PAYLOAD SETTLEMENTS ====> ", this.payload);
      if (this.payload?.settlement_id != null) {
        this.filterForm.patchValue({ settlement_id: this.payload.settlement_id });
        this.preloadBuildings(this.payload.settlement_id, this.payload.building_id);
      }
    });
  }

  preloadBuildings(settlement_id: any, id: any = null) {
    let buildingPayload: any = {
      page: 1,
      per_page: 300,
      settlement_id: settlement_id
    };

    this.store.getBuildings(buildingPayload).subscribe((data: any) => {
      this.buildings = data.data;
    });

    this.store.getFloors({
      page: 1,
      per_page: 300,
      building_id: id
    }).subscribe((data: any) => {
      this.floors = data.data;
    });

    this.filterForm.patchValue({ building_id: id });
    if (this.payload.floor_id != null) {
      this.filterForm.patchValue({ floor_id: this.payload.floor_id });
      this.preloadUnits(this.payload.floor_id, this.payload.unit_id);
    }
  }

  preloadFloors(building_id: any, id: any = null) {
    let floorPayload: any = {
      page: 1,
      per_page: 300,
      building_id: building_id
    };

    this.store.getFloors(floorPayload).subscribe((data: any) => {
      this.floors = data.data;
    });

    this.store.getUnits({
      page: 1,
      per_page: 300,
      floor_id: id
    }).subscribe((data: any) => {
      this.units = data.data;
    });

    this.filterForm.patchValue({ floor_id: id });
  }

  preloadUnits(floor_id: any, id: any = null) {
    let unitPayload: any = {
      page: 1,
      per_page: 300,
      floor_id: floor_id
    };

    this.store.getUnits(unitPayload).subscribe((data: any) => {
      this.units = data.data;
    });
    this.filterForm.patchValue({ unit_id: id });
    if (this.payload.unit_id != null) {
      this.filterForm.patchValue({ unit_id: this.payload.unit_id });
    }
  }

  selectSettlement(event: any) {
    let buildingPayload: any = {
      page: 1,
      per_page: 300,
      settlement_id: event.target.value
    };

    this.filterForm.patchValue({ building_id: '', floor_id: '', unit_id: '' });
    
    this.store.getBuildings(buildingPayload).subscribe((data: any) => {
      this.buildings = data.data;
      this.searchActive = true;
    });

    this.filterForm.patchValue({ settlement_id: event.target.value });

    this.billsSettlement.emit(event.target.value);
  }

  selectBuilding(event: any) {
    let unitPayload: any = {
      page: 1,
      per_page: 300,
      building_id: event.target.value
    };
    this.store.getFloors(unitPayload).subscribe((data: any) => {
      this.floors = data.data;
    });

    this.filterForm.patchValue({ floor_id: '', unit_id: '' });

    this.units = [];

    this.billsBuilding.emit(event.target.value);
  }

  selectFloor(event: any) {
    let unitPayload: any = {
      page: 1,
      per_page: 300,
      floor_id: event.target.value
    };
    this.store.getUnits(unitPayload).subscribe((data: any) => {
      this.units = data.data;
      console.log("UNITS => ", data);
    });

    this.filterForm.patchValue({ unit_id: '' });

    this.billsFloor.emit(event.target.value);
  }

  selectUnit(event: any) {
    this.billsUnit.emit(event.target.value);
  }

  selectSort(event: any) {
    console.log('SORT ====> ', event.target.value);
    this.billsSort.emit(event.target.value);
  }

  selectOrder(event: any) {
    console.log('ORDER ====> ', event.target.checked);
    this.billsOrder.emit(event.target.checked ? 'ASC' : 'DESC');
  }

  selectPerPage(event: any) {
    console.log('PER PAGE ====> ', event.target.value);
    this.billsPerPage.emit(event.target.value);
  }

  clearFilter() {    
    this.settlements = [];
    this.units = [];
    this.floors = [];
    this.buildings = [];
    this.searchActive = false;
    // this.fromDate = this.calendar.getToday();
    // this.toDate = this.calendar.getNext(this.calendar.getToday(), 'd', 10);
    this.filterForm.reset();
    this.loadSettlements();
    this.clear.emit();
  }
}
